import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {CommunicationService} from '../../../services/communication.service';
import {Router} from '@angular/router';
import { LoginSource } from '../../../classes/enums';

@Component({
  selector: 'app-login-reminder',
  templateUrl: './login-reminder.component.html',
  styleUrls: ['./login-reminder.component.scss']
})
export class LoginReminderComponent implements OnInit {
  @Input() isModal: boolean = false;
  @Input() titleId: string;
  @Output() closed = new EventEmitter<void>();
  constructor(private communicationService: CommunicationService, private router: Router) { }

  ngOnInit() {
  }

  onClick($event) {
    $event.preventDefault();
    this.communicationService.showSignIn.next(true);
  }

  openRegisterLogin() {
    this.closed.emit();
    this.router.navigate( ['/', { outlets: { popup: [ 'register-login', LoginSource.Generic ] } }]);
  }
}
